export const yacanConfig = {
  connection: {
    title: "YACAN connection",
    subtitle:
      "Connect your YACAN account to manage your guests' access with your locks.",
    connected: "Account connected",
    notConnected: "Not connected",
    info:
      "When you click <b>Connect with YACAN</b> a window will open to sign in and authorize access. The connection is saved for your whole account and used across all your properties.",
    connect: "Connect with YACAN",
    waiting: "Waiting for authorization...",
    connectedTitle: "YACAN account connected",
    authActive: "Authorization active",
    reauthorize: "Reauthorize",
    reauthorizeTitle: "Authorize again",
    disconnect: "Disconnect",
  },
  locks: {
    title: "Locks for this property",
    subtitle: "Select the YACAN locks that apply to <b>this property</b>.",
    selectedCount: "{count} selected",
    noneFound: "No locks were found in your YACAN account.",
    refresh: "Refresh",
    placeholder: "Select locks…",
    summary: "{count} lock(s) selected",
    empty: "No lock selected",
    lockFallback: "Lock {id}",
    save: "Save locks for this property",
    saving: "Saving...",
  },
  assign: {
    title: "Assignment (PMS)",
    subtitle: "Assign each lock to <b>Main door</b>, <b>Unit</b> or <b>Gate</b>.",
    assignedCount: "{count} assigned",
    info:
      "With YACAN, <b>guest access is managed by YACAN</b> based on the booking: no PINs are generated here. When a booking is confirmed, it syncs automatically with YACAN.",
    lockFallback: "Lock {id}",
    assignmentLabel: "Assignment",
    typeNone: "Unassigned",
    typeCommon: "Main door (shared)",
    typeUnit: "Apartment door",
    typeGate: "Gate / Garage",
    unitLabel: "Unit / Accommodation",
    unitPlaceholder: "Select a unit",
    unitFallback: "Unit {id}",
    save: "Save assignment",
    saving: "Saving...",
  },
  msg: {
    connectStartError: "The connection with YACAN couldn't be started",
    popupBlocked: "Allow pop-up windows to connect with YACAN.",
    connectError: "Error connecting with YACAN",
    connectSuccess: "YACAN account connected successfully",
    connectFailed: "Couldn't connect with YACAN",
    disconnectConfirm:
      "Disconnect your YACAN account? Bookings will no longer sync with YACAN.",
    disconnectSuccess: "YACAN account disconnected",
    disconnectError: "Couldn't disconnect",
    locksLoadError: "The locks couldn't be loaded",
    locksLoadError2: "Error loading YACAN locks",
    selectAtLeastOne: "Select at least one lock.",
    lockDefaultName: "YACAN lock",
    locksSaved: "Locks saved for this property",
    locksSaveError: "The locks couldn't be saved",
    saveError: "Error saving",
    selectUnitForApartment: "Select the unit for locks of type 'Apartment door'.",
    assignSaved: "Assignment saved successfully",
    assignSaveError: "The assignment couldn't be saved",
    assignSaveError2: "Error saving assignment",
  },
};
